import React, { useState } from 'react';
import { Search, Filter } from 'lucide-react';
import { CATEGORY_OPTIONS, DIFFICULTY_OPTIONS } from './examDashboardUtils';

/**
 * Welcome header + search and filters.
 * Search and filters are hidden by default; toggled with icons next to the title.
 */
function WelcomeAndFilters({
  welcomeTitle,
  welcomeSubtitle,
  search,
  onSearchChange,
  category,
  onCategoryChange,
  difficulty,
  onDifficultyChange,
}) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const filtersActive = category !== 'All' || difficulty !== 'All';
  const searchActive = Boolean(search?.trim());

  return (
    <header className="exam-dashboard__hero">
      <div className="exam-dashboard__hero-top">
        <h1 className="exam-dashboard__title">{welcomeTitle}</h1>
        <div className="exam-dashboard__hero-actions">
          <button
            type="button"
            className={`exam-dashboard__icon-toggle${searchOpen ? ' is-open' : ''}${searchActive ? ' has-active' : ''}`}
            onClick={() => setSearchOpen((v) => !v)}
            aria-expanded={searchOpen}
            aria-controls="exam-dashboard-search-panel"
            title={searchOpen ? 'Hide search' : 'Show search'}
          >
            <Search className="exam-dashboard__icon-toggle-svg" aria-hidden />
            <span className="sr-only">{searchOpen ? 'Hide search' : 'Show search'}</span>
          </button>
          <button
            type="button"
            className={`exam-dashboard__icon-toggle${filtersOpen ? ' is-open' : ''}${filtersActive ? ' has-active' : ''}`}
            onClick={() => setFiltersOpen((v) => !v)}
            aria-expanded={filtersOpen}
            aria-controls="exam-dashboard-filters"
            title={filtersOpen ? 'Hide filters' : 'Show filters'}
          >
            <Filter className="exam-dashboard__icon-toggle-svg" aria-hidden />
            <span className="sr-only">{filtersOpen ? 'Hide filters' : 'Show filters'}</span>
          </button>
        </div>
      </div>
      {welcomeSubtitle ? <p className="exam-dashboard__subtitle">{welcomeSubtitle}</p> : null}

      {searchOpen ? (
        <div id="exam-dashboard-search-panel" className="exam-dashboard__toolbar">
          <div className="exam-dashboard__search-wrap">
            <Search className="exam-dashboard__search-icon" aria-hidden />
            <label htmlFor="exam-dashboard-search" className="sr-only">
              Search exams
            </label>
            <input
              id="exam-dashboard-search"
              type="search"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by title, code, or company…"
              className="exam-dashboard__input"
              autoFocus
            />
          </div>
        </div>
      ) : null}

      {filtersOpen ? (
        <div id="exam-dashboard-filters" className="exam-dashboard__filters">
          <div className="exam-dashboard__field">
            <label htmlFor="filter-category" className="exam-dashboard__label">
              Category
            </label>
            <select
              id="filter-category"
              value={category}
              onChange={(e) => onCategoryChange(e.target.value)}
              className="exam-dashboard__select"
            >
              {CATEGORY_OPTIONS.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>
          <div className="exam-dashboard__field">
            <label htmlFor="filter-difficulty" className="exam-dashboard__label">
              Difficulty
            </label>
            <select
              id="filter-difficulty"
              value={difficulty}
              onChange={(e) => onDifficultyChange(e.target.value)}
              className="exam-dashboard__select"
            >
              {DIFFICULTY_OPTIONS.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>
        </div>
      ) : null}
    </header>
  );
}

export default WelcomeAndFilters;
